// src/components/TabGroup.js
import React, {useState} from "react";
import FadeInOut from "./FadeInOut";

const TabGroup = (prop) => {
    const [activeTab, setActiveTab] = useState("tabYt1");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div className="ytSide">
            <ul className="tabs groupYT">
                <li
                    className={activeTab === "tabYt1" ? "active" : ""}
                    rel="tabYt1"
                    onClick={() => handleTabClick("tabYt1")}
                    role="listitem"
                >
                    {prop?.data?.videoTitle1}
                </li>
                <li
                    className={activeTab === "tabYt2" ? "active" : ""}
                    rel="tabYt2"
                    onClick={() => handleTabClick("tabYt2")}
                    role="listitem"
                >
                    {prop?.data?.videoTitle2}
                </li>
            </ul>
            <div className="tab_container groupYT">
                <FadeInOut
                    show={activeTab === "tabYt1"}
                    duration={200}
                    className="tab_content"
                >
                    {prop.data?.video1?.split('v=')[1] ?
                        (<iframe
                                src={"https://www.youtube.com/embed/" + prop.data.video1.split('v=')[1].split('&')[0]}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        ) : (<iframe title="No video available"></iframe>)}

                </FadeInOut>
                <FadeInOut
                    show={activeTab === "tabYt2"}
                    duration={200}
                    className="tab_content"
                >
                    {prop.data?.video2?.split('v=')[1] ?
                        (<iframe
                                src={"https://www.youtube.com/embed/" + prop.data.video2.split('v=')[1].split('&')[0]}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        ) : (<iframe title="No video available"></iframe>)}
                </FadeInOut>
            </div>
        </div>
    );
};

export default TabGroup;
